import { useEffect } from 'react'

import { useAuth } from '../auth/use-auth'

/**
 * /sign-out route.
 *
 * Not a real page in the wireframes - sign-out is a menu action that ends
 * on `/sign-in`. We expose this route for direct-link sign-out (a CTA on
 * the access-denied page uses it). Behaviour:
 *
 *   1. Trigger `useAuth().signOut()` on mount. MSAL `logoutRedirect` clears
 *      the in-memory cache and bounces through Entra `/logout`.
 *   2. Render a quiet "Signing out..." status until the redirect happens.
 */
export function SignOutPage(): JSX.Element {
  const { signOut } = useAuth()

  useEffect(() => {
    void signOut()
  }, [signOut])

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full items-center justify-center text-text-muted"
    >
      <span aria-live="polite">Signing out...</span>
    </div>
  )
}
